var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_flex _gap-2 _shrink-0 _ai-sf" },
    [
      _vm._l(_vm.screenActions, function (action) {
        return _c(
          "tooltip",
          {
            key: action.key,
            attrs: {
              enabled: action.tooltipVisibility,
              text: action.tooltipText,
            },
          },
          [
            _c(
              action.component,
              _vm._b(
                {
                  tag: "component",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return action.fn.apply(null, arguments)
                    },
                  },
                },
                "component",
                action.props,
                false
              ),
              [
                _vm._v(
                  "\n            " + _vm._s(action.buttonText) + "\n        "
                ),
              ]
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.hasBallon
        ? _c(
            "div",
            { staticClass: "gfua-screen__dropdown-wrapper" },
            [
              _c(
                "toggle-trigger",
                {
                  class: _vm.ballonButtonClasses,
                  attrs: {
                    tag: "button",
                    "active-class": "gfu-table__button--selected",
                    "data-qa": "toggle-trigger-action:button",
                  },
                },
                [_c("base-icon", { attrs: { name: "ellipsis-v" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "toggle-container",
                {
                  staticClass:
                    "gfu-balloon gfu-balloon--right gfu-balloon--no-header gfua-screen__dropdown is-hidden",
                  attrs: {
                    tag: "div",
                    tabindex: "0",
                    "active-class": "is-open",
                    "close-on-click": "",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "gfu-balloon__content",
                      attrs: { "data-qa": "action-balloon-content" },
                    },
                    _vm._l(_vm.screenBalloonActions, function (action) {
                      return _c(
                        action.component,
                        _vm._b(
                          {
                            key: action.key,
                            tag: "component",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return action.fn.apply(null, arguments)
                              },
                            },
                          },
                          "component",
                          action.props,
                          false
                        ),
                        [
                          _c("base-icon", {
                            staticClass: "gfu-balloon__content-icon",
                            attrs: {
                              "is-fixed-width": true,
                              name: action.icon,
                            },
                          }),
                          _vm._v(
                            "\n                    " +
                              _vm._s(action.actionText) +
                              "\n                "
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }